<template>
  <div class="knowledge-product-box">
    <div class="knowledge-product-tag">
      <span
        :class="{ active: productCategory === '0' }"
        @click="categoryTag('0')"
        >全部</span
      >
      <span
          :class="{ active: productCategory === '2' }"
          @click="categoryTag('2')"
      >最新</span
      >
      <span
          :class="{ active: productCategory === '3' }"
          @click="categoryTag('3')"
      >HarmonyOS NEXT</span
      >
    </div>
    <div class="knowledge-product-list">
      <template v-if="productList.length > 0">
        <div v-for="el in productList" :key="el.id" @click="info(el.sourceUrl)">
          <h3>{{ el.newsTitle }}</h3>
          <p>
            <span>{{ el.newsDescription }}</span>
            <template v-if="el.newsCover">
              <img :src="el.newsCover" alt="" @error="handleError">
            </template>
          </p>
          <div>
            <p>
              来源：{{ el.sourceName }}
            </p>
            <span><a-icon type="clock-circle" />{{ dayjs(el.publishTime).format('YYYY-MM-DD') }}发布</span>
          </div>
        </div>
      </template>
      <template v-else>
        <a-empty />
      </template>
    </div>
    <div style="text-align: right;margin-top: 24px">
      <a-pagination
        show-size-changer
        show-quick-jumper
        hide-on-single-page
        :current="pages.current"
        :total="pages.total"
        @change="paginationChange"
        @showSizeChange="showSizeChange"
      />
    </div>
  </div>
</template>

<script>
import {
  getOpenProductCategory,
  getOpenProductList,
} from "@/api/openKnowledge";
import VImg from "@/components/VImg";
import dayjs from 'dayjs'
export default {
  components: {
    VImg,
  },
  data() {
    return {
      pages: {
        total: 0,
        current: 1,
        size: 10,
      },
      productCategory: '0',
      categoryList: [],
      productList: [],
      params:{
        newsCategory:'',
        sortKey:'publish_time',
      },
      defaultImg:require("@/assets/img/kctp.png"),
    };
  },
  mounted() {
    this.openProductList();
    this.openProductCategory();
  },
  methods: {
    dayjs,
    handleError(e) {
      e.target.src = this.defaultImg;
    },

    openProductList() {
      getOpenProductList(this.pages, this.params).then((res) => {
        console.log(res);
        this.productList = res.records;
        this.pages.total = res.total;
      });
    },
    openProductCategory() {
      getOpenProductCategory().then((res) => {
        this.categoryList = res;
      });
    },
    categoryTag(val) {
      this.pages.current=1
      this.productCategory = val;
      if(val==='0'){
        this.params.newsCategory=''
        this.params.sortKey='publish_time'
      }
      if(val==='2'){
        this.params.newsCategory=''
        this.params.sortKey='publish_time'
      }
      if(val==='3'){
        this.params.newsCategory='HarmonyOS NEXT'
        this.params.sortKey=''
      }
      this.openProductList();
    },
    paginationChange(page, pageSize) {
      this.pages.current = page;
      this.openProductList();
    },
    showSizeChange(current, size) {
      this.pages.size = size;
      this.openProductList();
    },
    info(sourceUrl) {
      window.open(sourceUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.knowledge-product-box {
  .knowledge-product-tag {
    display: flex;
    margin-bottom: 8px;
    > span {
      font-size: 18px;
      color: #666666;
      line-height: 64px;
      margin-right: 40px;
      cursor: pointer;
      transition: all 0.3s;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        color: #262626;
        font-weight: bold;
      }
    }
  }
  .knowledge-product-list {
    padding: 0 24px;
    background: #fff;
    > div {
      padding: 24px 0;
      cursor: pointer;
      border-bottom: 1px solid #e8e8e8;
      &:last-child {
        border-bottom: 0;
      }
      > h3 {
        font-weight: bold;
        font-size: 16px;
        color: #262626;
        line-height: 22px;
        margin-bottom: 16px;
      }
      > p {
        display: flex;
        > span {
          flex: 1;
          font-size: 14px;
          color: #666666;
          line-height: 24px;
          margin-bottom: 24px;
          max-height: 48px;
          overflow: hidden;
        }
        > img {
          width: 170px;
          height: 100px;
          margin-left: 24px;
        }
      }
      > div {
        display: flex;
        align-items: center;
        > p {
          margin-right: 32px;
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #999999;
          line-height: 20px;
        }
        > span {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #999999;
          line-height: 20px;
          > i {
            margin-right: 4px;
          }
        }
      }
    }
  }
}
</style>
